// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__3ry6o","bannerTitle":"banner_bannerTitle__REWr2","bannerSubTitle":"banner_bannerSubTitle__04b7W"};